import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './FactoringClientes.css';

const clients = [
  { name: 'Multibank', tagline: 'Servicios fiduciarios', style: 'alt' },
  { name: 'Canal Bank', tagline: 'Banca empresarial', style: 'alt' },
  { name: 'Rimonim', tagline: 'Hospitalidad gourmet', style: 'dark' },
  { name: 'Mi Amiga', tagline: 'Retail & consumo', style: '' },
  { name: 'Rodelag', tagline: 'Comercio y electrodomésticos', style: '' },
  { name: 'HeroExpress', tagline: 'Logística y courier', style: 'dark' },
  { name: 'Balboa Factoring', tagline: 'Finanzas corporativas', style: '' },
  { name: 'Panacredit', tagline: 'Crédito y leasing', style: 'alt' },
  { name: 'ISEMEC', tagline: 'Ingeniería eléctrica', style: '' },
  { name: 'Mi Éxito', tagline: 'Soluciones financieras', style: 'alt' },
  { name: 'Brig', tagline: 'Retail & lifestyle', style: '' },
  { name: 'Banco General', tagline: 'Banca regional', style: 'dark' },
  { name: 'BICSA', tagline: 'Comercio exterior', style: 'dark' },
  { name: 'PriceSmart', tagline: 'Retail mayorista', style: '' },
  { name: 'Factoring Empresarial', tagline: 'Factoring multisector', style: 'alt' },
  { name: 'IATA', tagline: 'Aviación y transporte', style: '' },
  { name: 'Banco Aliado', tagline: 'Banca corporativa', style: 'dark' }
];

function FactoringClientes() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='clientes-page'>
      <Helmet>
        <title>Clientes TEKINS Factoring | Casos de éxito</title>
        <meta
          name='description'
          content='Empresas líderes en Panamá confían en TEKINS Factoring Framework para administrar sus operaciones de factoring, confirming y financiamiento estructurado.'
        />
      </Helmet>

      <section className='clientes-hero'>
        <h1>Confían en TEKINS Factoring Framework</h1>
        <p>
          Una red de instituciones financieras, retail y servicios que respaldan más de un billón de dólares negociados con nuestro
          framework desde 1994.
        </p>
      </section>

      <section className='clientes-wrapper'>
        <div>
          <h2>Alianzas y clientes destacados</h2>
          <p>
            Cada logotipo representa una operación viva que exige cumplimiento DGI, continuidad operativa y soporte especializado. Estas
            compañías eligieron TEKINS para gestionar factoring, confirming, crédito y procesos de recaudo.
          </p>
        </div>

        <div className='logo-grid'>
          {clients.map((client) => (
            <article className={`logo-card ${client.style}`} key={client.name}>
              <span>{client.name}</span>
              <small>{client.tagline}</small>
            </article>
          ))}
        </div>

        <div>
          <h2>¿Quieres conocer el caso completo?</h2>
          <p>
            Podemos compartir referencias y lecciones aprendidas de estos despliegues. Agenda una conversación con nuestro equipo de
            especialistas para explorar el roadmap ideal para tu entidad.
          </p>
        </div>

        <div className='return-cta'>
          <Link className='factoring-button primary' to='/Factoring'>Regresar a Factoring</Link>
        </div>
      </section>
    </div>
  );
}

export default FactoringClientes;
